import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const fetchOrder = (orderId: string, setOrder: Function, setLoading: Function, refreshToken: Function, retry = false) => {
  const token = localStorage.getItem('sph-access');

  axios.get(`${API_URL}/orders/${orderId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => setOrder(response.data))
    .catch(async (error) => {
      if (error.status === 401 && !retry) {
        try {
          await refreshToken();
          fetchOrder(orderId, setOrder, setLoading, refreshToken, true);
        } catch (err) {
          console.error('An error occurred on refreshing token', err);
        }
      } else {
        console.error('An error occurred on fetching order informations', error);
        // TODO: Improve display
        // alert("Echec de la récupération des informations de la commande");
      }
    })
    .finally(() => setLoading(false));
}
